// extracted by mini-css-extract-plugin
export var chevron = "_2d-d";
export var disabled = "_2d-b";
export var error = "_2d-c";
export var hideBorder = "_2d-1";
export var icon = "_2d-e";
export var input = "_2d-0";
export var large = "_2d-f";
export var open = "_2d-9";
export var placeholder = "_2d-a";
export var regular = "_2d-5";
export var singleRowInput = "_2d-2";
export var singleSelectInput = "_2d-3 _2d-0";
export var small = "_2d-4";
export var spinnerContainer = "_2d-i";
export var tag = "_2d-7";
export var tagsContainer = "_2d-8";
export var tagsInput = "_2d-6 _2d-0";
export var xSmall = "_2d-g";
export var xxSmall = "_2d-h";